import styled from "styled-components";
// import colors from "assets/scss/colors.scss";

const StyleWrapper = styled.div`
  .header{
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 1.5rem 1rem;
    gap: 24px;
  }
  h3{
    margin 1.5rem 0;
    color: var(--text-black, #1A1C1F);
    /* Heading En/Heading 6 */
    font-family: Tawuniya;
    font-size: 1rem;
    font-style: normal;
    font-weight: 700;
    line-height: 130%; /* 1.3rem */
    letter-spacing: -0.03rem;
  }

  .p-dropdown {
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 4px 10px rgb(9 30 66 / 6%);
    border-radius: 4px;
    border: none;
    padding: 10px 0px;
    height: auto;
    height: 70px;
  }
  .p-dropdown-label {
    font-size: 1rem !important;
    font-weight: 800 !important;
    color: rgb(26, 28, 31) !important;

  }

  .p-float-label label {
    font-weight: 400;
    font-size: 1rem;
    color: var(--text-dark-gray, #455560); 
  }

  .p-float-label .p-inputwrapper-focus ~ label,
  .p-float-label .p-inputwrapper-filled ~ label {
    top: 1rem !important;
    font-size: 0.75rem;
  }

  .declaration{
    padding-bottom: 6rem;
  }
  

  .footer{
    position: fixed;
    bottom: 0;
    z-index: 99;
    margin-top: 1.5rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 1rem 1rem 1rem;
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
    flex: none;
    order: 2;
    flex-grow: 0;
    z-index: 0;
    border-radius: 0.75rem 0.75rem 0rem 0rem;
    .p-button{
      width: 100%;
      margin: 0 auto;
      align-items: center;
      justify-content: center;
    }
  }
  
`;
export default StyleWrapper;
